import { call, put, spawn } from 'redux-saga/effects';

import { deleteRegFilingType } from '@api/filingTypes';
import {
  filingTypesDeleteFailure,
  filingTypesDeleteSuccess,
} from '@store/entityJurisdictions/entityJurisdictionsDetail/filingTypes/filingTypes.reducer';
import { toastError, toastSuccess } from '@store/notifications';

import { filingTypesFetchSaga } from '../filingTypesFetchSaga';

export const filingTypesDeleteSaga = function* ({ payload }) {
  try {
    yield call(deleteRegFilingType, payload.filingId);

    yield put([
      filingTypesDeleteSuccess(),
      toastSuccess({
        message: {
          defaultMessage: '{filingName} successfully deleted.',
          id: 'pages.registrations.filing-types-delete.notification.success',
        },
        values: {
          filingName: payload.filingName,
        },
      }),
    ]);

    yield spawn(filingTypesFetchSaga, {
      payload: { entityJurisdictionId: payload.entityJurisdictionId },
    });
  } catch (error) {
    const { nonFieldErrors, hasNonFieldError } = error.data || {};

    yield put([
      toastError(
        hasNonFieldError
          ? {
              message: nonFieldErrors,
            }
          : {
              message: {
                defaultMessage: 'Failed to delete {filingName}.',
                id: 'pages.registrations.filing-types-delete.notification.error',
              },
              values: {
                filingName: payload.filingName,
              },
            }
      ),
      filingTypesDeleteFailure(),
    ]);
  }
};
